import { dateFormatter } from "../../utils/tableDataFormatter";
import ReferenceConditionRenderer from "../../components/AddCIPAndShutdown/pinReferenceCellRender";

const getHeader = (name, unit) => {
  return name.replace("<unit>", `(${unit})`);
};
export const DATA_VISUALISATION_COL_DEF = (t, defaultSettingUnit) => [
  {
    headerName: t("analysisColumn.date"),
    field: "date",
    sortable: true,
    valueFormatter: dateFormatter,
    flex: 1,
    minWidth: 200,
    headerClass: "custom-Header-cip-user-table",
  },

  {
    headerName: getHeader(
      t("analysisColumn.filtrateFlowrate"),
      defaultSettingUnit["flow"]
    ),
    field: "filtrate_flowrate",
    sortable: true,
    flex: 1,
    minWidth: 200,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: getHeader(
      t("analysisColumn.feedTemperature"),
      defaultSettingUnit["temperature"]
    ),
    field: "feed_temp",
    sortable: true,
    flex: 1,
    minWidth: 200,
    headerClass: "custom-Header-cip-user-table",
  },
  // {
  //   headerName: getHeader(
  //     t("analysisColumn.permeatePressure"),
  //     defaultSettingUnit["pressure"]
  //   ),
  //   field: "permeate_pressure",
  //   sortable: true,
  //   flex: 1,
  //   minWidth: 200,
  //   headerClass: "custom-Header-cip-user-table",
  // },
  {
    headerName: getHeader(
      t("analysisColumn.feedFlowrate"),
      defaultSettingUnit["flow"]
    ),
    field: "feed_flowrate",
    sortable: true,
    flex: 1,
    minWidth: 200,
    headerClass: "custom-Header-cip-user-table",
  },
  // {
  //   headerName: getHeader(
  //     t("analysisColumn.concentrateFlowrate"),
  //     defaultSettingUnit["flow"]
  //   ),
  //   field: "concentrate_flowrate",
  //   sortable: true,
  //   flex: 1,
  //   minWidth: 200,
  //   headerClass: "custom-Header-cip-user-table",
  // },
  {
    headerName: getHeader(
      t("analysisColumn.filtrateSuspended"),
      defaultSettingUnit["filtrate_suspended"]
    ),
    field: "filtrate_suspended",
    sortable: true,
    flex: 1,
    minWidth: 200,
    headerClass: "custom-Header-cip-user-table",
  },

  {
    headerName: getHeader(
      t("analysisColumn.feedPressure"),
      defaultSettingUnit["pressure"]
    ),
    field: "feed_pressure",
    sortable: true,
    flex: 1,
    minWidth: 200,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: getHeader(
      t("analysisColumn.tmpDrop"),
      defaultSettingUnit["pressure"]
    ),
    field: "tmp_drop",
    sortable: true,
    flex: 1,
    minWidth: 250,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: getHeader(
      t("analysisColumn.filtratePressure"),
      defaultSettingUnit["pressure"]
    ),
    field: "filtrate_pressure",
    sortable: true,
    flex: 1,
    minWidth: 200,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: getHeader(
      t("analysisColumn.feedSuspended"),
      defaultSettingUnit["feed_suspended"]
    ),
    field: "feed_suspended",
    sortable: true,
    flex: 1,
    minWidth: 200,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: getHeader(
      t("analysisColumn.normalizedFiltrateFlow"),
      defaultSettingUnit["flow"]
    ),
    field: "norm_filtrate_flow",
    sortable: true,
    flex: 1,
    minWidth: 250,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: getHeader(
      t("analysisColumn.normalizedTmp"),
      defaultSettingUnit["pressure"]
    ),
    field: "norm_tmp",
    sortable: true,
    flex: 1,
    minWidth: 200,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    colId: "referenceCondition",
    lockPinned: true,
    pinned: "right",
    width: 200,
    headerName: t("ValueStrings.referenceCondition"),
    cellRenderer: ReferenceConditionRenderer,
  },
  // {
  //   headerName: t("analysisColumn.normalizedSaltPassage"),
  //   field: "norm_salt_passage",
  //   sortable: true,
  //   flex: 1,
  //   minWidth: 200,
  //   headerClass: "custom-Header-cip-user-table",
  // },
];
